import { Component, Fragment } from 'react';

import { Box, Pagination } from '@mui/material';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { flowRight as compose } from 'lodash';

import AxlTable from '../../../components/JTable';
import { getPaymentStatusColor } from '../../../Utils/paymentStatus';
import styles from './styles';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndexes: [],
      detailedItem: {},
    };
  }

  componentDidMount() {
    const { store, baseUrl, keepData } = this.props;
    if (!keepData) {
      store.reset();
    }

    if (baseUrl) {
      store.setBaseUrl(baseUrl);
    }

    // store.search();
  }

  selectItem = (item) => (e) => {
    const { multipleSelect, store } = this.props;

    if (!store) return null;
    const { result, idField } = store;

    const { selectedIndexes, prevBatch } = this.state;
    const inSelectedIndex = store.selectedItems.indexOf(item[store.idField]);
    const isShift = e.shiftKey;
    const currentIndex = result.items.indexOf(item);

    if (isShift) {
      if (selectedIndexes.length > 0 && multipleSelect) {
        const lastSelectedIndex = selectedIndexes[selectedIndexes.length - 1];

        const allIds = toJS(result.items.map((i) => i[idField]));
        let tobeAddIds = [];
        if (currentIndex > lastSelectedIndex) {
          tobeAddIds = allIds.slice(lastSelectedIndex, currentIndex + 1);
        } else {
          tobeAddIds = allIds.slice(currentIndex, lastSelectedIndex + 1);
        }

        if (prevBatch?.selectedIndex && prevBatch.selectedIndex === lastSelectedIndex) {
          store.selectedItems = store.selectedItems.filter((id) => !prevBatch.addedIds.includes(id));
        }

        tobeAddIds = tobeAddIds.filter((id) => !store.selectedItems.includes(id));

        store.selectedItems = store.selectedItems.concat(tobeAddIds);

        this.setState({
          prevBatch: {
            selectedIndex: lastSelectedIndex,
            addedIds: tobeAddIds,
          },
        });
      } else {
        this.setState({ selectedIndexes: selectedIndexes.concat([currentIndex]) });
        if (multipleSelect) {
          store.selectedItems.push(item[store.idField]);
        } else {
          store.selectedItems = [item[store.idField]];
        }
      }
    } else if (inSelectedIndex >= 0) {
      store.selectedItems.splice(inSelectedIndex, 1);
      // remove prev shift index
      this.setState({ selectedIndexes: selectedIndexes.splice(selectedIndexes.indexOf(currentIndex), 1) });
    } else {
      this.setState({ selectedIndexes: selectedIndexes.concat([currentIndex]) });
      if (multipleSelect) {
        store.selectedItems.push(item[store.idField]);
      } else {
        store.selectedItems = [item[store.idField]];
      }
    }
  };

  onSelectPage = (page) => {
    const { store } = this.props;

    store.filters.page = page;
    store.search();
  };

  viewDetail = (item) => {
    // console.log('hello', item);
    const { detailedItem } = this.state;
    this.setState({ detailedItem: item.id === detailedItem.id ? {} : item });
  };

  render() {
    const { detailedItem } = this.state;
    const { store, alt, renderer, allowSelect, disabledIds, pagination, hiddenIfEmpty, header, styleContainer } = this.props;

    const { result, fields, filters, idField, details, listDetails } = store;
    if (hiddenIfEmpty && (!result?.items || result.items.length < 1)) {
      return null;
    }

    return (
      <Fragment>
        {header && header}
        <div style={{ ...styles.list, ...styleContainer }}>
          <AxlTable style={styles.tableStyle}>
            <AxlTable.Header>
              <AxlTable.Row>
                {fields &&
                  fields.map((field, i) => {
                    const props = { ...field, filters, alt };

                    return <List.HeaderCell key={`header-${i}`} {...props} />;
                  })}
              </AxlTable.Row>
            </AxlTable.Header>
            <AxlTable.Body>
              {result?.items &&
                result.items.length > 0 &&
                result.items.map((item, index) => {
                  const isDisabled = disabledIds && disabledIds.length > 0 && disabledIds.includes(item[idField]);
                  const isOldTransaction = item.actual_end_ts && moment().diff(moment(item.actual_end_ts), 'days') > 45;
                  const statusColor = item.status ? getPaymentStatusColor(item.status) : 'inherit';

                  const style = {
                    ...(isDisabled ? styles.disabledCell : {}),
                    ...(!isDisabled && store.isSelected(item, index) ? styles.selected : {}),
                    ...(item.type === 'PAYMENT - DEDUCT' ? styles.deduct : {}),
                    ...(isOldTransaction ? styles.oldTransaction : {}),
                    ...(allowSelect && !isDisabled ? { cursor: 'pointer' } : {}),
                  };

                  const props = { style };
                  if (allowSelect && !isDisabled) {
                    props['onClick'] = this.selectItem(item, index);
                  }

                  return (
                    <Fragment key={`row-${index}`}>
                      <AxlTable.Row {...props}>
                        {fields.map((field, i2) => {
                          const isDetailField =
                            field.name === 'row_detail' &&
                            (['OUTVOICE - SURCHARGE'].includes(item.type) ||
                              (item.assignment_id != null && ['OUTVOICE - ROUTE_DRIVING'].includes(item.type)));

                          const fieldStyle = {
                            color: 'inherit',
                            textAlign: 'center',
                            ...(field.name === 'status' ? { color: statusColor, fontWeight: 700 } : {}),
                            ...(field.name === 'amount' ? { fontFamily: 'AvenirNext-DemiBold' } : {}),
                            ...(field.highlight ? styles.highlightCell : {}),
                            ...(field.nowrap ? styles.nowrap : {}),
                            ...(isDetailField ? styles.details : {}),
                          };

                          if (isDetailField) {
                            return (
                              <AxlTable.Cell key={`field_${index}${i2}`} style={fieldStyle}>
                                <div
                                  onClick={() => {
                                    this.viewDetail(item);
                                  }}
                                >
                                  {detailedItem.id === item.id ? 'Hide' : 'Show'} Details
                                </div>
                              </AxlTable.Cell>
                            );
                          }

                          return (
                            <AxlTable.Cell key={`field_${index}${i2}`} style={fieldStyle}>
                              {!renderer[field.name] ? item[field.name] : renderer[field.name](item[field.name], item, result)}
                            </AxlTable.Cell>
                          );
                        })}
                      </AxlTable.Row>
                      {detailedItem.id === item.id && (
                        <AxlTable.Row>
                          <AxlTable.Cell colSpan={8} key={`field_detail`} style={style}>
                            <Box sx={{ display: 'flex' }}>
                              {(['OUTVOICE - SURCHARGE'].includes(item.type) ? listDetails : details)
                                .filter((detail) => {
                                  // Only show working_hours if the item has hour_rate
                                  if (detail.name === 'working_hours' && !item.hour_rate) {
                                    return false;
                                  }
                                  return true;
                                })
                                .map((detail) => (
                                  <Box key={`detail-${detail.name}`} sx={{ flex: 1, ...styles.detailWrapper, ...detail.styles }}>
                                    <div style={{ marginBottom: 8 }}>{detail.label}</div>
                                    <div style={{ color: '#000' }}>
                                      {['OUTVOICE - SURCHARGE'].includes(item.type)
                                        ? item.driverGroups.map((dg, i) => <div key={`detail-${i}`}>{dg[detail.name]}</div>)
                                        : !renderer[detail.name]
                                          ? item[detail.name]
                                          : renderer[detail.name](item[detail.name], item, result)}
                                    </div>
                                  </Box>
                                ))}
                            </Box>
                          </AxlTable.Cell>
                        </AxlTable.Row>
                      )}
                    </Fragment>
                  );
                })}
            </AxlTable.Body>
          </AxlTable>
        </div>
        {pagination && result.total_pages > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', padding: "10px 15px" }}>
            <Pagination count={result.total_pages} page={filters.page} onChange={(e, page) => this.onSelectPage(page)} color="primary" size="small" />
          </Box>
        )}
      </Fragment>
    );
  }

  static HeaderCell = class extends Component {
    render() {
      const { label, filters, orderField, highlight, nowrap, toggleOrder, alt } = this.props;

      const props = {};
      // style
      const style = {
        fontWeight: 900,
        whiteSpace: 'nowrap',
        ...(highlight ? styles.highlightCell : {}),
        ...(nowrap ? styles.nowrap : {}),
        ...(alt ? styles.alternative : {}),
      };
      props['style'] = style;

      if (orderField) {
        props['isActive'] = filters && filters.order_by === orderField;
        props['up'] = !(filters?.desc);
        if (toggleOrder) props['onClick'] = toggleOrder(orderField);
      }

      return <AxlTable.HeaderCell {...props}>{label}</AxlTable.HeaderCell>;
    }
  };
}

const ListCompose = compose(inject('store'), observer)(List);

export default ListCompose;
